import React from 'react';
import PropTypes from 'prop-types';
import { reduxFormPropTypes } from 'constants/propTypes';
import GenericButton from 'components/Button';
import withFormContext from '../withFormContext';

const Button = props => {
  const { form, children, disabled, ...rest } = props;
  const { type } = rest;
  const { submitting } = form;

  return (
    <GenericButton {...rest} disabled={disabled || submitting} waiting={submitting && type === 'submit'}>
      {children}
    </GenericButton>
  );
};

Button.propTypes = {
  type: PropTypes.string,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  form: reduxFormPropTypes.context,
};

Button.defaultProps = {
  type: 'button',
};

const ButtonWithFormContext = withFormContext(Button);

ButtonWithFormContext.TYPES = GenericButton.TYPES;

export default ButtonWithFormContext;
